<template>
  <UApp :locale="uiLocale">
    <Default>
      <router-view />
    </Default>
  </UApp>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import * as locales from '@nuxt/ui/locale'

import Default from '@/layouts/Default.vue'

const { locale } = useI18n()

// Keep Nuxt UI's built-in component texts in sync with the vue-i18n locale.
const uiLocale = computed(() => (locales as Record<string, (typeof locales)['en']>)[locale.value] ?? locales.en)
</script>
